<!-- Upload progress -->
<div class="upload-progress" *ngIf="file && !error && !isLocal() && !isNew()">
  <div class="upload-progress-header">
    <div class="uploading-header-caption">{{ 'attachment_Uploading_Caption' | xsI18n }}</div>
    <div class="uploading-header-information">
      <div class="attachment-file-name" sa-ellipsis [fullText]="activity.details?.fileName">
        {{ activity.details?.fileName }}
      </div>
      <div class="attachment-file-size">({{ activity.details?.fileSize }})</div>
      <div class="attachment-file-size">({{ activity.fileSize | xsFileSizeFormatPipe }})</div>
    </div>
  </div>
  <div class="upload-progressbar">
    <mat-progress-bar max="100" animate="false" [value]="progress"></mat-progress-bar>
    <!-- <progressbar max="100" animate="false" value="progress"></progressbar> -->
    <div class="upload-progress-percentage">{{ progress | number : 0 }}%</div>
    <div class="xs-btn btn-primary cancel-upload-button" type="button" (click)="cancel()">{{ 'xs_cancel_label' | xsI18n }}</div>
  </div>
</div>

<!-- Local attachment details -->
<xs-local-attachment-activity
  *ngIf="isLocal() && file"
  [parentActivity]="activity"
>
</xs-local-attachment-activity>

<!-- Existing attachment details -->

<xs-existing-attachment-activity
  *ngIf="!isNew() && !file"
  [parentActivity]="activity"
  [canEdit]="canEdit"
  [canDelete]="canEdit"
  [isSPPMode]="isSPPMode"
  [activityCtrl]="activityCtrl"
  (onDelete)="delete()"
  (onError)="setError(error, canRetry)"
>
</xs-existing-attachment-activity>

<xs-attachment-note
  *ngIf="showNote()"
  [parentActivity]="activity"
  [activityCtrl]="activityCtrl"
  (updateEditing)="updateEditing($event)"
  (saveNote)="saveNote($event)"
  [canEdit]="canEdit"
  [error]="error"
>
</xs-attachment-note>

<!-- Attachment error -->
<div class="attachment-error-footer" *ngIf="error">
  <div class="attachment-error-caption">{{ 'attachment_Error' | xsI18n : error }}</div>
  <div class="error-buttons">
    <div class="xs-btn btn-primary cancel-button" type="button" (click)="cancel()" [style.visibility]="canRetry ? 'visible' : 'hidden'">
      {{ 'xs_cancel_label' | xsI18n }}
    </div>
    <div class=" xs-btn btn-primaryretry-button" type="button" (click)="retry()" [style.visibility]="canRetry ? 'visible' : 'hidden'">
      {{ 'attachment_Retry_Button' | xsI18n }}
    </div>
    <div
      class="xs-btn btn-primary ok-button"
      type="button"
      (click)="clearError()"
      [style.visibility]="canRetry || !enableDismissError ? 'visible' : 'hidden'"
    >
      {{ 'attachment_OK_Caption' | xsI18n }}
    </div>
  </div>
</div>
